import type { AppState } from '@/store/store.ts';
import { isIsoDate } from '@/utils/date.ts';

export const selectSwapTile = (state: AppState, tileId: string) => state.swap[tileId];

export const selectSwapIsPriceable = (state: AppState, tileId: string): boolean => {
  const tile = selectSwapTile(state, tileId);

  return (
    tile !== undefined &&
    tile.tradeCapture.status === 'CHECKED' &&
    tile.tradeCapture.isReadyToPrice &&
    isIsoDate(tile.properties.nearExpiryDate ?? '') &&
    isIsoDate(tile.properties.farExpiryDate ?? '')
  );
};
